<template>
  <div>
    <v-autocomplete
      :items="items"
      item-text="nombre"
      item-value="id"
      :label="label"
      persistent-hint
      return-object
      v-model="valor_default"
      @change="updateValue"
      outlined
    ></v-autocomplete>
  </div>
</template>
<script>
  export default {
    inheritAttrs: false,
    props: {
      label: {
        type: String,
        default: ""
      },
      value: [String, Number],
      items: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        valor_default: ""
      };
    },
    created() {
      this.valor_default = this.value;
    },
    methods: {
      updateValue(event) {
        this.$emit("input", event.id);
      }
    }
  };
</script>